// src/components/admin/AdminRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ user, children }) => {
  // 1. 如果沒登入，踢回首頁 (或登入頁)
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // 2. 如果登入了但不是 admin，踢回首頁
  if (user.role !== 'admin') {
    alert('權限不足，無法進入管理後台');
    return <Navigate to="/" replace />;
  }

  // 3. 通過檢查，顯示後台內容
  return children;
};

export default AdminRoute;